import { useEffect, useRef } from 'react'

interface InstagramEmbedProps {
  html: string
}

/**
 * Renderiza o código de incorporação Behold (behold.so) para exibir o feed
 * do Instagram automaticamente. Re-executa os <script> contidos no embed,
 * pois dangerouslySetInnerHTML não executa scripts automaticamente.
 */
export default function InstagramEmbed({ html }: InstagramEmbedProps) {
  const containerRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const el = containerRef.current
    if (!el || !html) return

    // Limpa o conteúdo anterior
    el.innerHTML = ''

    // Cria um DocumentFragment a partir do HTML
    const fragment = document.createRange().createContextualFragment(html)

    // Re-injeta scripts como novos elementos para que o browser os execute
    const scripts: HTMLScriptElement[] = []
    fragment.querySelectorAll('script').forEach(oldScript => {
      const newScript = document.createElement('script')
      Array.from(oldScript.attributes).forEach(attr =>
        newScript.setAttribute(attr.name, attr.value)
      )
      newScript.textContent = oldScript.textContent
      // Remove o script do fragment para não duplicar
      oldScript.parentNode?.removeChild(oldScript)
      scripts.push(newScript)
    })

    // Insere o HTML (sem scripts)
    el.appendChild(fragment)

    // Insere os scripts separadamente para forçar execução
    scripts.forEach(s => el.appendChild(s))

    // Cleanup: remove scripts adicionados ao desmontar
    return () => {
      scripts.forEach(s => {
        if (s.parentNode) s.parentNode.removeChild(s)
      })
    }
  }, [html])

  return (
    <div
      ref={containerRef}
      className="w-full min-h-[200px]"
    />
  )
}
